import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'
import { getGenericMappingArrayFromGenericMappingByKey } from './utils'

export const ASANA_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  assignee: {
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'The user who is assigned to the task',
    enumFromCollapseEsQuery: true,
    order: 0,
  },
  createdBy: {
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'The user who created the task',
    enumFromCollapseEsQuery: true,
    order: 1,
  },
  completedAt: {
    type: GenericMappingType.DATE,
    name: 'Completion date',
    description: 'The date and time the task was completed',
    order: 2,
  },
  completedBy: {
    type: GenericMappingType.KEYWORD,
    name: 'Completed By',
    description: 'The user who completed the task',
    enumFromCollapseEsQuery: true,
    order: 3,
  },
  startedAt: {
    type: GenericMappingType.DATE,
    name: 'Start date',
    description: 'The date and time the task was started',
    order: 4,
  },
  dueAt: {
    type: GenericMappingType.DATE,
    name: 'Due date',
    description: 'The date and time the task is due',
    order: 5,
  },
  approvalStatus: {
    type: GenericMappingType.KEYWORD,
    name: 'Approval status',
    description: 'The approval status of the task',
    enum: ['pending', 'approved', 'rejected', 'changes_requested'],
    order: 6,
  },
  tags: {
    type: GenericMappingType.KEYWORD,
    name: 'Tags',
    description: 'The tags associated with the task',
    enumFromTermsAggEsQuery: true,
    order: 7,
  },
  projects: {
    type: GenericMappingType.KEYWORD,
    name: 'Projects',
    description: 'The projects the task is associated with',
    enumFromTermsAggEsQuery: true,
    order: 8,
  },
  teams: {
    type: GenericMappingType.KEYWORD,
    name: 'Teams',
    description: 'The teams the task is associated with',
    enumFromTermsAggEsQuery: true,
    order: 9,
  },
  sections: {
    type: GenericMappingType.KEYWORD,
    name: 'Sections',
    description:
      'The sections the task is associated with including the project',
    enumFromTermsAggEsQuery: true,
    order: 10,
  },
} satisfies GenericMappingByKey)

export const ASANA_GENERIC_MAPPINGS =
  getGenericMappingArrayFromGenericMappingByKey(ASANA_GENERIC_MAPPINGS_BY_KEY)
